import { render, staticRenderFns } from "./campaign-targets-partner.vue?vue&type=template&id=798797c6&scoped=true&"
import script from "./campaign-targets-partner.vue?vue&type=script&lang=js&"
export * from "./campaign-targets-partner.vue?vue&type=script&lang=js&"
import style0 from "./campaign-targets-partner.vue?vue&type=style&index=0&id=798797c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798797c6",
  null
  
)

export default component.exports